module.exports = __webpack_public_path__ + "static/media/rocket-dynamic-clay.b92e1631.png";